import { ScreenSize } from '@/styles/legacyComponentLibraryTheme';
import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles({ name: 'MuiImageGrid3ColWithDescription' })(
  ({ brandType, brandColors, breakpoints, type, typography }) => ({
    contentContainer: {
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
    },
    container: {
      maxWidth: typography.pxToRem(1440),
      marginTop: typography.pxToRem(0),
      padding: typography.pxToRem(36),
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        paddingLeft: typography.pxToRem(16),
        paddingRight: typography.pxToRem(16),
      },
    },
    titleContainer: {
      marginBottom: typography.pxToRem(36),
      paddingLeft: typography.pxToRem(22),
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        paddingLeft: 0,
      },
    },
    title: {
      ...type['44_medium'],
      textWrap: 'pretty',
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        ...brandType['heading-xxs'],
      },
    },
    subtitle: {
      ...type['20_regular'],
      paddingTop: typography.pxToRem(20),
      paddingBottom: typography.pxToRem(20),
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        ...type['16_medium'],
      },
    },
    columnTitle: {
      ...type['24_medium'],
      paddingTop: typography.pxToRem(12),
    },
    columnDescription: {
      ...type['20_regular'],
      paddingTop: typography.pxToRem(8),
      paddingBottom: typography.pxToRem(12),
    },
    contentSection: {
      display: 'flex',
      flexDirection: 'column',
      paddingLeft: typography.pxToRem(22),
      paddingRight: typography.pxToRem(22),
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        marginTop: typography.pxToRem(20),
        paddingLeft: 0,
        paddingRight: 0,
      },
    },
    contentSectionVertical: {
      display: 'flex',
      flexDirection: 'row',
      paddingLeft: typography.pxToRem(22),
      paddingRight: typography.pxToRem(22),
      paddingTop: typography.pxToRem(27),
      paddingBottom: typography.pxToRem(27),
      borderTop: `0.5px solid ${brandColors.textPrimary}`,
      '&:last-child': {
        borderBottom: `0.5px solid ${brandColors.textPrimary}`,
      },
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        padding: 0,
        flexDirection: 'column',
        marginTop: typography.pxToRem(20),
        border: 'none',
      },
    },
    button: {
      paddingTop: typography.pxToRem(16),
      paddingBottom: typography.pxToRem(40),
    },
    colContentContainer: {
      display: 'flex',
      flexDirection: 'row',
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        flexDirection: 'column',
      },
    },
    colContentContainerVertical: {
      display: 'flex',
      flexDirection: 'column',
    },
    colTextContent: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
    },
    colTextContentVertical: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      justifyContent: 'center',
    },
    image: {
      width: '100%',
    },
    imageVertical: {
      marginRight: typography.pxToRem(80),
      objectFit: 'contain',
      width: typography.pxToRem(460),
      height: typography.pxToRem(280),
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        width: '100%',
        height: 'auto',
        marginRight: 0,
      },
    },
    horizontalRow: {
      paddingTop: '1rem',
      display: 'flex',
    },
    horizontalColumn: {
      flex: 1,
      padding: 0,
    },
    horizontalCentralColumn: {
      flex: 1,
      paddingLeft: typography.pxToRem(44),
      paddingRight: typography.pxToRem(44),
    },
  })
);

export default useStyles;
